<template>
  <v-card flat class="pa-2">
    <v-card-text>
      <v-combobox
        :loading="loading"
        v-model="choseModel"
        outlined
        dense
        :items="model"
        item-text="title"
      />
    </v-card-text>
    <atom-spinner
      v-if="loading"
      :animation-duration="1500"
      :size="100"
      class="mx-auto"
      color="var(--v-primary-base)"
    />
    <custom-tabs
      v-if="!loading && !!tabItems && !!assetsValue"
      v-model="tabs"
      :tab-items="tabItems"
      grow
    >
      <template v-slot:staticItems>
        <v-tab-item v-for="(component, i) in tabItems" :key="i">
          <component
            :is="component.component"
            v-model="assetsValue[component.value]"
            :items="items"
            :loading="dLoading"
          />
        </v-tab-item>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import assetsCom from "./components/assetsCom.vue";
import { AtomSpinner } from "epic-spinners";
import { Bus } from "../../../main";

export default {
  name: "myAssets",
  props: { value: Object },
  components: {
    assetsCom,
    AtomSpinner,
  },
  data() {
    return {
      tabs: null,
      tabItems: [],
      loading: false,
      items: [],

      // loading
      loading: false,
      dLoading: false,

      // sorce of sites
      model: [],
      choseModel: null,
    };
  },

  computed: {
    assetsValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    tabs: {
      immediate: true,
      handler() {
        this.getInformation();
      },
    },
    tabItems: {
      deep: true,
      handler(val) {
        this.getInformation();
      },
    },
    choseModel: {
      deep: true,
      handler(val) {
        this.syncData(val);
        Bus.$emit("model", val);
      },
    },
  },

  mounted() {
    this.getServices();
  },

  methods: {
    getInformation() {
      this.dLoading = true;
      this.$api
        .get("/v2/gold/db", {
          params: {
            type: this.tabItems[this.tabs ?? 0].value?.replace(
              `${this?.choseModel?.value}_`,
              ""
            ),
            length: 1000,
            source: this?.choseModel?.value,
          },
        })
        .then(({ data }) => {
          this.items = data.data.data;
        })
        .catch((err) => this.getInformation())
        .finally(() => (this.dLoading = false));
    },

    async getServices() {
      const fixData = (data) => {
        let keys = {};
        data?.map((items) => {
          items.tabs.forEach((item) => {
            keys = {
              ...keys,
              [items.value + "_" + item.value]:
                this.assetsValue[items.value + "_" + item.value] ?? [],
            };
          });
        });
        return keys;
      };
      this.loading = true;
      this.$api
        .get("/v2/gold/source")
        .then(({ data }) => {
          this.$emit("input", fixData(data.data));
          // this.value = fixData(data.data);
          this.model = data.data;
          this.choseModel = data.data[0];
        })
        .catch(() => {
          this.$toast.warning(this.$t("resources_upload_error"));
        })
        .finally(() => (this.loading = false));
    },

    syncData(val) {
      let tabs = val?.tabs?.map((tab) => {
        return {
          ...tab,
          value: val.value + "_" + tab.value,
          component: "assetsCom",
        };
      });
      this.tabItems = tabs;
    },
  },
};
</script>

<style></style>
